'use client';

import React, { useMemo, useState, memo } from 'react';
import { useCountDown } from 'ahooks';
import { useTranslation } from '@/i18n/client';
import PopoverWithIcon from '../popoverWithIcon';
import OpcDetail from '../opcDetail';
import styles from './index.module.scss';
import { PROMOTION_TYPE } from '@/apis/dp/floor.interface';

/** 倒计时使用状态枚举 */
export enum USE_COUNTDOWN {
  /** 使用倒计时 */
  USE = 1,
  /** 不使用倒计时 */
  NOT_USE = 0,
}

/** 预售状态枚举 */
export enum PRESALE_STATUS {
  /** 未开始 */
  NOT_STARTED = 'not_started',
  /** 进行中 */
  IN_PROGRESS = 'in_progress',
  /** 已结束 */
  ENDED = 'ended',
}

/** 促销楼层数据接口 */
export interface ProductPromotionFloor {
  /** 促销类型 */
  type: PROMOTION_TYPE;
  /** 促销描述 */
  desc: string;
  /** 是否使用倒计时 */
  useCountdownText: USE_COUNTDOWN;
  /** 预售文案 */
  promotionTimeText: string;
  /** 倒计时时间（秒） */
  countdown: number;
  promotionPop: {
    sceneId: string;
    title?: string;
  };
}

interface PreSaleProps {
  productPromotionFloor: ProductPromotionFloor;
}

const PreSale: React.FC<PreSaleProps> = memo(({ productPromotionFloor }) => {
  const {
    desc,
    useCountdownText,
    promotionTimeText,
    countdown,
    promotionPop: { sceneId, title },
  } = productPromotionFloor || {};

  const [, formattedRes] = useCountDown({
    leftTime: countdown * 1000,
    interval: 1000,
    onEnd: () => {
      window.location.reload();
    },
  });

  // 格式化显示时间
  const formattedTime = useMemo(() => {
    const { hours, minutes, seconds } = formattedRes;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }, [formattedRes]);

  return (
    <div className={styles.preSale}>
      <span className={styles.desc}>{desc}</span>
      {useCountdownText === USE_COUNTDOWN.USE ? (
        <>
          <span className={styles.presaleText}> {promotionTimeText}</span>
          <span className={styles.countdown} suppressHydrationWarning={true}>
            {formattedTime}
          </span>
        </>
      ) : (
        <span className={styles.presaleText}>{promotionTimeText}</span>
      )}
      <PopoverWithIcon>
        <OpcDetail scene={sceneId} title={title} />
      </PopoverWithIcon>
    </div>
  );
});

PreSale.displayName = 'PreSale';

export default PreSale;
